import PermNavLink from "./PermNavLink";

export default PermNavLink